import { TOUR_TRANSLATIONS } from "../translations"

export const getAmazonPPKpisSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="amazon-pp-kpis-filters"]',
            title: t.amazonPPKpisFilters.title,
            content: t.amazonPPKpisFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="amazon-pp-kpis-table"]',
            title: t.amazonPPKpisTable.title,
            content: t.amazonPPKpisTable.content,
        },
    ]
}
